export const licenseKey =
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjdhYjVmMDlkLWJkNjMtNDZiNy05NDY0LTEzZmNhZjUwNjJjNyIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.aR1epUfI2LwbrmNASeLkZaD63Rz1cW3DQF0QqATnxMeXD7O8HBt7KY1QbzVgzN+sDXSEiBG0sRL9Y6oaeKowlPAdtvUyqAfIukK4sefiFjJLYI7j1Pg6SJATaHF+elhrGwrdDw==';
